import { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useAnalytics } from '~/context/analytics';

interface SpamWarningBannerProps {
  messagePartId: string;
}

export function SpamWarningBanner({ messagePartId }: SpamWarningBannerProps) {
  const {
    amplitude: { track },
  } = useAnalytics();

  // Analytics: fire once per render of this flagged message
  useEffect(() => {
    track('dm_spam_warning_shown', { messagePartId });
  }, [messagePartId, track]);

  return (
    <div className="mb-1 flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
      <span>
        This message was flagged as possible spam or a scam. Don&apos;t share contact info, click links, or send money.
      </span>
    </div>
  );
}
